export const traitKeysWithStylesheets = [
    'fontFamily',
    'designTextShadow',
    'googleFont',
    'designBorder',
    'designBoxShadow',
    'designImageShadow',
    'animateTextAppear',
    'animateTextDisappear',
    'animateTextEffect',
    'animateMotion',
    'animateBoxShadow',
    'animateWithBackface',
    'animateBackground',
    'animateAttention',
    'animateReturning',
    'animateInOut',
    'animateAppear',
    // 'animateEntrance',
    'animateDisappear',
    'hoverCss',
    'iHoverLib',
    'imagehoverTextEffect',
    'libClickeffect',
    'boxShadowLib',
    'ribbonPack',
    'stylishBorders',
    'libImageHover'
];
export function resolveAutoBorderName(at) {
    let borderName = at.trait.value;
    if (borderName === 'auto:actor') {
        borderName = (at.context.actor && at.context.actor.tid) || 'test';
    }
    if (borderName === 'auto:parentActor') {
        borderName = (at.context.actor.context.parentContext && at.context.actor.context.parentContext.actor.tid) || 'test';
    }
    return borderName;
}
